//https://sistemas.ucasal.edu.ar/sagbackend/api/v1/mi-perfil/lovs/tipo-documentos?tdocu=0&ndocu=1
import { AUTH_URL } from "../../config/config";
import { connection } from "../../utils/connection";


const generateTokenService = async ({ callbacks }) => {
    const response = await connection({ method: 'GET', url: `${AUTH_URL.GENERATE_TOKEN}` });
    if (typeof callbacks === "function") {   
        callbacks({
            errors: ['Ocurrio un error con el servidor. Intenta nuevamente mas tarde'],
            not_autorized: false,
            success: true,
            data: {token: response.data}
        });
        //callbacks(response);
    }
}

export default generateTokenService;
